import { render, staticRenderFns } from "./s-imgZoom.vue?vue&type=template&id=51c2d270&scoped=true"
import script from "./s-imgZoom.vue?vue&type=script&lang=js"
export * from "./s-imgZoom.vue?vue&type=script&lang=js"
import style0 from "./s-imgZoom.vue?vue&type=style&index=0&id=51c2d270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2d270",
  null
  
)

export default component.exports